import React from 'react';
import CardEmpty from '../../../../Utils/Cards/CardEmpty';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import SolidosTable from './Tables/SolidosTable/SolidosTable';
import LatexTable from './Tables/LatexTable/LatexTable';
import SkimTable from './Tables/SkimTable/SkimTable';

let CostoMateriaPrimaForm = props => {
    const { handleSubmit, currency, convertirMoneda, setCurrency } = props;

    const handleCurrencyChange = (event) => {
        const nuevaMoneda = event.target.value;
        
        setCurrency(nuevaMoneda);

        convertirMoneda({
            latex_data: props.latex_data,
            solido_data: props.solido_data,
            skim_data: props.skim_data,
            item: props.item,
            change: props.change,
            currency: nuevaMoneda
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className='col-sm-12 p-0'>
                <CardEmpty
                    isMarginButtom
                    noShadow>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <h6 className="mb-0"><strong>COSTO DE MP DE SÓLIDOS</strong></h6>
                        </div>
                        <div className="d-flex align-items-center">
                            <label htmlFor="currency-selector" style={{ marginRight: '10px', marginBottom: '0' }}>
                                Expresado en:
                            </label>
                            <select
                                id="currency-selector"
                                className="form-control custom-select"
                                style={{ width: '180px', border: 'none', outline: 'none', boxShadow: 'none' }}
                                value={currency}
                                onChange={handleCurrencyChange}
                            >
                                <option value="USD">Dólar US$</option>
                                <option value="GTQ">Quetzales (GTQ)</option>
                            </select>
                        </div>
                    </div>
                    <SolidosTable
                        {...props}
                    />
                </CardEmpty>
                <CardEmpty
                    isMarginButtom
                    noShadow>
                    <div className="col-md-3 p-0 mt-2">
                        <div className="md-12">
                            <h6 className="mb-4"><strong>COSTO DE MP LÁTEX</strong></h6>
                        </div>
                    </div>
                    <LatexTable
                        {...props}
                    />
                </CardEmpty>
                <CardEmpty
                    isMarginButtom
                    noShadow>
                    <div className="col-md-3 p-0 mt-2">
                        <div className="md-12">
                            <h6 className="mb-4"><strong>COSTO DE MP SKIM</strong></h6>
                        </div>
                    </div>
                    <SkimTable
                        {...props}
                    />
                </CardEmpty>
                <div className='buttons-box mt-5'>
                    <button type="submit" className="btn btn-primary m-4 btn-modal">
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </form>
    )
};
const formName = 'CostosMPForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    return {
        latex_data: selector(state, 'latex_data'),
        solido_data: selector(state, 'solido_data'),
        skim_data: selector(state, 'skim_data'),
    };
};

export default connect(mapStateToProps)(
    reduxForm({
        form: formName,
    })(CostoMateriaPrimaForm)
);
